import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../iBoxx/services/api.service';
import {UtilService} from '../../iBoxx/services/UtilService';
import {LoaderService} from '../../iBoxx/shared/loader/loader-service.services';
import {Router} from '@angular/router';

@Component({
  selector: 'app-carbon-landing-page',
  templateUrl: './carbon-landing-page.component.html',
  styleUrls: ['./carbon-landing-page.component.scss']
})
export class CarbonLandingPageComponent implements OnInit {

  tabList = ['home'];
  indices: any[] = [];
  errorMessage = '';
  showErrorMsg = false;
  alertType = 'error';

  constructor(private apiService: ApiService, public utilService: UtilService, private loader: LoaderService, private route: Router) {
    // @ts-ignore
    this.tabList = JSON.parse(window.sessionStorage.getItem('tabListForCarbon')) ? JSON.parse(window.sessionStorage.getItem('tabListForCarbon')) :
      ['home', 'documentation'];
  }

  ngOnInit(): void {
    this.loader.show();
    this.apiService.getAllCarbonIndices().subscribe((resp: any) => {
      this.indices = resp.sort((resp1: any, resp2: any) => resp1.indexLevel.id < resp2.indexLevel.id ? -1 : 1);
      this.loader.hide();
    },
      (error) => {
        this.errorMessage = 'Unable to fetch Carbon indices from server. Please contact indices@ihsmarkit.com';
        this.showErrorMsg = true;
        console.error('error caught in component');
        this.loader.hide();
      });
  }

  openIndexDetails(index: any): void{
    const currentTab = index.id + ' : ' + index.indexName;
    if (!this.tabList.includes(currentTab)){
      this.tabList.push(currentTab);
    }
    window.sessionStorage.setItem('tabListForCarbon', JSON.stringify(this.tabList));
    this.route.navigateByUrl('Carbon/details/index?id=' + index.id);
  }

  openTab(event: any): void{
    if (event === 'documentation'){
      this.route.navigateByUrl('Indices/docs/page?docFor=Carbon');
    }else if (event !== 'home'){
      this.openIndexDetails(this.indices.find((index: any) => index.indexLevel.id === event.split(' : ')[0]).indexLevel);
    }
  }
  closeAlert(): void {
    this.showErrorMsg = false;
  }
}
